import React, { Component } from 'react';
import { withStyles, Typography, Dialog, DialogTitle, DialogContent, DialogContentText, Checkbox, Link, Button, FormControlLabel } from '@material-ui/core';
import styles from './ConsentDialog.css';

class ConsentDialog extends Component {

    constructor(props){
        super();
        this.state = {
            checked: props.checked
        }
    }

    changeConsent = (event) => {
        this.setState({
            checked: event.target.checked
        })
    }



    render() {
        const {open,  classes, saveConsentCookies} = this.props;

        return (
            <Dialog
                disableBackdropClick={true}
                disableEscapeKeyDown={true}
                open={open}
            >
                <DialogTitle id="scroll-dialog-title">Terms of Use</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        By submitting images you acknowledge that:
                        <ul>
                            <li>You have permissions to perform analysis on them.</li>
                            <li>You allow the owner of this site to use the submitted images for bioimage informatics research purposes.</li>
                            <li>You allow the owner of this site for anonymized publication of the submitted images.</li>
                        </ul>
                        We store IP address.<br/>
                        <FormControlLabel
                            control={<Checkbox checked={this.state.checked} onChange={this.changeConsent}/>}
                            label={
                                <Typography variant="body1" component="span">
                                    Check here to indicate that you have read and agree to our <Link href={'/cookies'}>Cookies Policy</Link> and <Link href={'/privacy'}>Privacy Policy</Link>.
                                </Typography>
                            }
                            classes={{root: classes.formControlLabel}}
                        />

                        <Button variant="contained" color="primary" fullWidth={true} onClick={() => saveConsentCookies(this.state.checked)}>Continue</Button>

                    </DialogContentText>
                </DialogContent>

            </Dialog>
        );
    }
}

export default withStyles(styles, {withTheme: true})(ConsentDialog);
